<template>
  <div class="earthquake-page">
    <header-title
      title="حملة رمضان"
      titlePrevious="الرئيسية "
      color="var(--danger)"
    />

    <div>
      <swiper
        class="swiper-autoplay"
        :options="swiperOptions"
        :navigation="true"
        :dir="$store.state.appConfig.isRTL ? 'ltr' : 'rtl'"
      >
        <swiper-slide style="" v-for="(slide, i) in slides" :key="i">

          <div
            :style="{
              'background-image': `url('${slide.img}')`,
            }"
            style="position: relative"
            class="bacg"
          >
            <div
              class="w-100"
              style="
                z-index: 2;
                opacity: 0.4;
                background-color: black;
                height: 600px;
                position: absolute;
              "
            ></div>
            <div style="z-index: 3; position: relative" class="title_des">
              <div>
                <h3 class="text-white"> رمضان... تشارك بالخير </h3>
              </div>
                <p class="text-white b_slider"> 
                  تحضيراً لشهر رمضان المبارك و في إطار من العمل التشاركي ... قامت وزارة الشؤون الإجتماعية و العمل بالتنسيق مع وزارات الأوقاف و الإدارة المحلية و التجارة الداخلية و حماية المستهلك و اتحادرات غرف التجارة و الصناعة و المنظمات غير الحكومية لتنسيق جهود العمل الخيري عبر حملة "رمضان... تشارك بالخير"
                </p>
            </div>
          </div>
        </swiper-slide>
        <div slot="button-next" class="swiper-button-next text-white" />
        <div slot="button-prev" class="swiper-button-prev text-white" />
        <div slot="pagination" class="swiper-pagination" />
      </swiper>
    </div>
    <div class="container px-2 my-3">
      <span class="py-50 px-1 bg-primary mr-1 title-radius"></span>
      <span class="h1">الإحصائيات المطلوبة </span>
    </div>
    <b-row class="my-3 mx-auto container">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="12"
        v-for="(card, i) in medCards"
        :key="i"
      >
        <EarthquakeStatisticCard v-bind="card" />
      </b-col>
    </b-row>
    <div class="container px-2 my-3">
      <span class="py-50 px-1 bg-primary mr-1 title-radius"></span>
      <span class="h1"> المنظمات غير الحكومية المساهمة </span>
    </div>
    <b-row class="my-3 mx-auto container">
      
      <div class="col-lg-12 col-md-12 col-12 mb-3">
          <basc-card>
            <div>
              <div
                v-if="ngo_list.data.length === 0"
                class="d-flex justify-content-center flex-wrap"
              >
                <b-skeleton v-for="n in 8" :key="n" class="skeleton_ngo_list">
                </b-skeleton>
              </div>
              <!-- <div v-if="loading" class="loading-overlay"></div> -->
              <div v-else>
                <div class="row">
                  <div
                    class="col-lg-3 col-md-4 col-sm-6 col-6 my-1"
                    v-for="org in ngo_list.data"
                    :key="org.id"
                  >
                    <ngo-info
                      :id="org.id"
                      :name_ngo="org.name_ar"
                      :governorate="org.governorate"
                    ></ngo-info>
                  </div>
                  <alert
                    v-if="ngo_list.data.length === 0"
                    class="w-100"
                    :massage="$t('alert')"
                  ></alert>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center">
              <pagination
                v-model="currentPage"
                :total-rows="ngo_list.pagination.total_row"
                :per-page="ngo_list.pagination.per_page"
                align="middle"
                class="mt-3 mb-2"
              >
              </pagination>
            </div>
          </basc-card>
        </div>
    </b-row>
    <!-- <div class="w-100 bg-warning py-4">
      <div class="container">
        <h4 class="container text-light">
          أرقام الحسابات المخصصة لاستجابة زلزال سوريا
        </h4>
        <div class="d-flex mt-2 pl-1">
          <div class="d-flex w-50 flex-column">
            <h6 class="text-light">
              الأمانة السورية للتنمية-حماة : 2050262888028
            </h6>
            <h6 class="text-light my-2">
              الأمانة السورية للتنمية-حلب : 2050262888007
            </h6>
            <h6 class="text-light">
              الأمانة السورية للتنمية-اللاذقية : 2050262888008
            </h6>
          </div>
          <div class="d-flex w-50 flex-column">
            <h6 class="text-light">حماة : 0943043603 - 0951333901</h6>
            <h6 class="text-light my-2">حلب : 0943043498 - 0951333884</h6>
            <h6 class="text-light">اللاذقية : 0943043543 - 0943043890</h6>
          </div>
        </div>
      </div>
      <b-row class="container">
        <b-col>
          <ul>
            <li></li>
          </ul>
        </b-col>
      </b-row>
    </div> -->
  </div>
</template>
<script>
import HeaderTitle from "../../components/HeaderTitle.vue";
import EarthquakeFeaturedCard from "../../components/EarthquakeFeaturedCard.vue";
import EarthquakeStatisticCard from "../../components/EarthquakeStatisticCard.vue";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { BImg, BRow, BCol , BSkeleton } from "bootstrap-vue";
import BascCard from "../../components/BascCard.vue";
import "swiper/css/swiper.css";
import Pagination from "@/components/pagination";
import NgoInfo from "../../components/NgoInfo";
// import { mapGetters } from 'vuex/types/helpers';

export default {
  components: {
    Swiper,
    SwiperSlide,
    BImg,
    BRow,
    BCol,
    HeaderTitle,
    EarthquakeFeaturedCard,
    EarthquakeStatisticCard,
    BSkeleton,
    BascCard ,
    Pagination ,
    NgoInfo
  },
  data() {
    return {
      slides: [
        { img: require("./assets/slider/slide_1.png") },
      ],
      currentPage : null,
      
      medCards: [
        {
          title: "عدد المطابخ",
          rightNumber: "18",
          leftNumber: "مطبخ",
          img: require("./assets/st_1.jpg"),
        },
        {
          title: "عدد وجبات الإفطار",
          rightNumber: "18",
          leftNumber: "وجبة",
          img: require("./assets/st_1.jpg"),
        },
        {
          title: "عدد المستفيدين",
          rightNumber: "18",
          leftNumber: "مستفيد",
          img: require("./assets/st_1.jpg"),
        },
        {
          title: "قيمة المساعدات النقدية",
          rightNumber: "18",
          leftNumber: "ل.س",
          img: require("./assets/st_1.jpg"),
        },
        {
          title: "ثياب العيد",
          rightNumber: "18",
          leftNumber: "",
          img: require("./assets/st_1.jpg"),
        },
        {
          title: "عدد السلل الغذائية",
          rightNumber: "18",
          leftNumber: "سلة",
          img: require("./assets/st_1.jpg"),
        },
        {
          title: "عدد الوجبات الجافة المقدمة",
          rightNumber: "18",
          leftNumber: "وجبة",
          img: require("./assets/st_1.jpg"),
        },
        {
          title: "عدد المنظمات غير الحكومية المساهمة بالحملة",
          rightNumber: "18",
          leftNumber: "منظمة",
          img: require("./assets/st_1.jpg"),
        },
      ],
      ngo_list:{
        data:[],
        pagination:{
          current_page:1 ,
          last_page: 96 ,
          per_page: 16 ,
          total_row: 260
        }
      },
      all_data:{
        data:[
          {
            "governorate": "حماه",
            "id": 4,
            "name_ar": "جمعية حماة للخدمات الاجتماعية"
          },
          {
            "governorate": "درعا",
            "id": 12,
            "name_ar": "جمعية داعل الخيرية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 17,
            "name_ar": "مؤسسة فرصة "
          },
          {
            "governorate": "دمشق",
            "id": 18,
            "name_ar": "تشبيك"
          },
          {
            "governorate": "اللاذقية",
            "id": 19,
            "name_ar": "الأمل والإحسان الخيرية"
          },
          {
            "governorate": "دير الزور",
            "id": 26,
            "name_ar": "جمعية المرأة العربية "
          },
          {
            "governorate": "طرطوس",
            "id": 30,
            "name_ar": "جمعية البر والخدمات في بانياس"
          },
          {
            "governorate": "حمص",
            "id": 31,
            "name_ar": "جمعية رعاية الطفل"
          },
          {
            "governorate": "درعا",
            "id": 40,
            "name_ar": "جمعية البر للخدمات الاجتماعية بدرعا"
          },
          {
            "governorate": "دمشق",
            "id": 44,
            "name_ar": "إغاثة المرضى الفقراء"
          },
          {
            "governorate": "دمشق",
            "id": 55,
            "name_ar": "الاسعاف الخيري التعليمي"
          },
          {
            "governorate": "حماه",
            "id": 65,
            "name_ar": "جمعية رعاية المكفوفين والصم والبكم في حماة"
          },
          {
            "governorate": "حماه",
            "id": 70,
            "name_ar": "جمعية مصياف الخيرية"
          },
          {
            "governorate": "حماه",
            "id": 72,
            "name_ar": "الجمعية الخيرية للرعاية الاجتماعية في حماة"
          },
          {
            "governorate": "دمشق",
            "id": 78,
            "name_ar": "الأنصار الخيرية"
          },
          {
            "governorate": "الحسكة",
            "id": 81,
            "name_ar": "القديس منصور"
          },
          {
            "governorate": "دمشق",
            "id": 101,
            "name_ar": "اتحاد الجمعيات الخيرية"
          },
          {
            "governorate": "درعا",
            "id": 102,
            "name_ar": "جمعية الامام النووي في نوى"
          },
          {
            "governorate": "حماه",
            "id": 125,
            "name_ar": "الجمعية الخيرية الاصلاحية في البيضا"
          },
          {
            "governorate": "دمشق",
            "id": 136,
            "name_ar": "مأذنة الشحم"
          },
          {
            "governorate": "دمشق",
            "id": 138,
            "name_ar": "الغراء"
          },
          {
            "governorate": "حمص",
            "id": 160,
            "name_ar": "الجمعية الخيرية الإسلامية "
          },
          {
            "governorate": "دمشق",
            "id": 177,
            "name_ar": "البر والإصلاح الخيرية"
          },
          {
            "governorate": "حمص",
            "id": 186,
            "name_ar": "جمعية النهضة العربية"
          },
          {
            "governorate": "دير الزور",
            "id": 201,
            "name_ar": "جمعية حماية الاحداث"
          },
          {
            "governorate": "اللاذقية",
            "id": 212,
            "name_ar": "أصدقاء الفقير الأرثوذكسية"
          },
          {
            "governorate": "اللاذقية",
            "id": 214,
            "name_ar": "البر والخدمات الاجتماعية في جبلة"
          },
          {
            "governorate": "دمشق",
            "id": 215,
            "name_ar": "الفتح الإسلامي"
          },
          {
            "governorate": "ريف دمشق",
            "id": 228,
            "name_ar": "الجمعية الخيرية لإغاثة المحتاجين بدوما"
          },
          {
            "governorate": "دير الزور",
            "id": 235,
            "name_ar": "جمعية النهضة النسائية"
          },
          {
            "governorate": "اللاذقية",
            "id": 238,
            "name_ar": "رعاية الطفولة"
          },
          {
            "governorate": "حلب",
            "id": 242,
            "name_ar": "اتحاد الجمعيات الخيرية"
          },
          {
            "governorate": "حماه",
            "id": 245,
            "name_ar": "جمعية الامل لحماية الاحداث في حماة"
          },
          {
            "governorate": "حمص",
            "id": 257,
            "name_ar": "جمعية البر والخدمات الاجتماعية "
          },
          {
            "governorate": "دمشق",
            "id": 274,
            "name_ar": "الزاهرة الخيرية"
          },
          {
            "governorate": "دمشق",
            "id": 278,
            "name_ar": "زهرة المدائن الخيرية"
          },
          {
            "governorate": "القنيطرة",
            "id": 291,
            "name_ar": "نهضة الريف"
          },
          {
            "governorate": "ريف دمشق",
            "id": 345,
            "name_ar": "جمعية البر والاحسان بالزبداني"
          },
          {
            "governorate": "السويداء",
            "id": 349,
            "name_ar": "الرعاية الاجتماعية"
          },
          {
            "governorate": "حمص",
            "id": 358,
            "name_ar": "جمعية باب السباع "
          },
          {
            "governorate": "ريف دمشق",
            "id": 360,
            "name_ar": "إنعاش الفقير في التل "
          },
          {
            "governorate": "ريف دمشق",
            "id": 371,
            "name_ar": "جمعية مسرابا الخيرية"
          },
          {
            "governorate": "طرطوس",
            "id": 375,
            "name_ar": "الجمعية الخيرية الإسلامية الجعفرية في طرطوس"
          },
          {
            "governorate": "ريف دمشق",
            "id": 390,
            "name_ar": "جمعية جسرين"
          },
          {
            "governorate": "السويداء",
            "id": 395,
            "name_ar": "تنظيم الاسرة السورية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 397,
            "name_ar": "جمعية داريا الاسلامية الخيرية"
          },
          {
            "governorate": "طرطوس",
            "id": 400,
            "name_ar": "الجمعية الجعفرية في صافيتا"
          },
          {
            "governorate": "دمشق",
            "id": 424,
            "name_ar": "أصدقاء دمشق"
          },
          {
            "governorate": "ريف دمشق",
            "id": 429,
            "name_ar": "البر والاحسان في معضمية القلمون"
          },
          {
            "governorate": "ريف دمشق",
            "id": 444,
            "name_ar": "جيرود بتجود"
          },
          {
            "governorate": "حمص",
            "id": 452,
            "name_ar": "جمعية كرم الشامي "
          },
          {
            "governorate": "ريف دمشق",
            "id": 459,
            "name_ar": "جمعية حرستا الخيرية"
          },
          {
            "governorate": "السويداء",
            "id": 464,
            "name_ar": "المتقاعدين المدنيين"
          },
          {
            "governorate": "دمشق",
            "id": 469,
            "name_ar": "رعاية الأطفال المصابين بالشلل الدماغي"
          },
          {
            "governorate": "دمشق",
            "id": 477,
            "name_ar": "السورية للمعوقين جسديا"
          },
          {
            "governorate": "اللاذقية",
            "id": 477,
            "name_ar": "الجمعية السورية للمعوقين جسدياً"
          },
          {
            "governorate": "الرقة",
            "id": 490,
            "name_ar": "جمعية رعاية المكفوفين"
          },
          {
            "governorate": "ريف دمشق",
            "id": 494,
            "name_ar": "حفير الفوقا"
          },
          {
            "governorate": "درعا",
            "id": 503,
            "name_ar": "جمعية الامام النووي فرع الحارة"
          },
          {
            "governorate": "درعا",
            "id": 506,
            "name_ar": "جمعية الصنمين الخيرية"
          },
          {
            "governorate": "حمص",
            "id": 536,
            "name_ar": "جمعية الانشاءات الخيرية "
          },
          {
            "governorate": "دمشق",
            "id": 544,
            "name_ar": "الغيث الخيرية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 544,
            "name_ar": "الغيث في الزبداني"
          },
          {
            "governorate": "ريف دمشق",
            "id": 562,
            "name_ar": "جمعية علي بن ابي طالب في بيت سحم"
          },
          {
            "governorate": "ريف دمشق",
            "id": 576,
            "name_ar": "جمعية حلبون الخيرية"
          },
          {
            "governorate": "القنيطرة",
            "id": 586,
            "name_ar": "الجمعية العامة للتأهيل والمصابين بالألغام"
          },
          {
            "governorate": "دمشق",
            "id": 588,
            "name_ar": "أمل الغد للشلل الدماغي"
          },
          {
            "governorate": "القنيطرة",
            "id": 590,
            "name_ar": "الجولان الخيرية في القنيطرة"
          },
          {
            "governorate": "حلب",
            "id": 604,
            "name_ar": "جمعية المستقبل"
          },
          {
            "governorate": "حلب",
            "id": 605,
            "name_ar": "جمعية التآلف"
          },
          {
            "governorate": "القنيطرة",
            "id": 606,
            "name_ar": "المبرات الخيريةلابناء الجولان"
          },
          {
            "governorate": "السويداء",
            "id": 614,
            "name_ar": "الكفر الخيرية"
          },
          {
            "governorate": "الحسكة",
            "id": 633,
            "name_ar": "جعية البر والخدمات الاجتماعية بالحسكة"
          },
          {
            "governorate": "الحسكة",
            "id": 633,
            "name_ar": "البروالخدمات الاجتماعية بالقامشلي"
          },
          {
            "governorate": "السويداء",
            "id": 636,
            "name_ar": "عرمان الخيرية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 640,
            "name_ar": "جمعية معضمية الشام الخيرية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 650,
            "name_ar": "اشرفية صحنايا الخيرية الاجتماعية"
          },
          {
            "governorate": "دمشق",
            "id": 666,
            "name_ar": "حفظ النعمة الخيرية"
          },
          {
            "governorate": "دمشق",
            "id": 674,
            "name_ar": "الندى"
          },
          {
            "governorate": "طرطوس",
            "id": 680,
            "name_ar": "جمعية المرأة الذكية"
          },
          {
            "governorate": "الرقة",
            "id": 682,
            "name_ar": "جمعية الاحسان"
          },
          {
            "governorate": "درعا",
            "id": 698,
            "name_ar": "جمعية غزالة الخيرية"
          },
          {
            "governorate": "دمشق",
            "id": 730,
            "name_ar": "حقوق الطفل الخيرية"
          },
          {
            "governorate": "حمص",
            "id": 732,
            "name_ar": "جمعية الانماء الخيري "
          },
          {
            "governorate": "ريف دمشق",
            "id": 755,
            "name_ar": "افاق المستقبل بالنشابية"
          },
          {
            "governorate": "حماه",
            "id": 760,
            "name_ar": "جمعية محردة الخيرية"
          },
          {
            "governorate": "دمشق",
            "id": 793,
            "name_ar": "التنمية والتطوير للخير"
          },
          {
            "governorate": "حماه",
            "id": 795,
            "name_ar": "جمعية صوران الخيرية"
          },
          {
            "governorate": "دمشق",
            "id": 802,
            "name_ar": "القدس الخيرية"
          },
          {
            "governorate": "اللاذقية",
            "id": 811,
            "name_ar": "بشائر النور"
          },
          {
            "governorate": "ريف دمشق",
            "id": 820,
            "name_ar": "احلام الطفولة لذوي الاحتياجات الخاصة"
          },
          {
            "governorate": "دمشق",
            "id": 849,
            "name_ar": "حي الزهور الخيرية"
          },
          {
            "governorate": "إدلب",
            "id": 868,
            "name_ar": "جمعية البر والخدمات الاجتماعية "
          },
          {
            "governorate": "الرقة",
            "id": 885,
            "name_ar": "جمعية الإعاقة والتأهيل"
          },
          {
            "governorate": "حمص",
            "id": 889,
            "name_ar": "جمعية الغدير الخيرية "
          },
          {
            "governorate": "الحسكة",
            "id": 911,
            "name_ar": "جمعية المودة"
          },
          {
            "governorate": "حماه",
            "id": 920,
            "name_ar": "جمعية حيالين الخيرية"
          },
          {
            "governorate": "دمشق",
            "id": 923,
            "name_ar": "الخيرية الفلسطينية"
          },
          {
            "governorate": "دير الزور",
            "id": 924,
            "name_ar": "جمعية رعاية المكفوفين"
          },
          {
            "governorate": "طرطوس",
            "id": 929,
            "name_ar": "الوردية الخيرية"
          },
          {
            "governorate": "القنيطرة",
            "id": 932,
            "name_ar": "جمعية رعاية المكفوفين"
          },
          {
            "governorate": "طرطوس",
            "id": 943,
            "name_ar": "البتول للخدمات الإنسانية"
          },
          {
            "governorate": "اللاذقية",
            "id": 979,
            "name_ar": "فرح لدعم أطفال السرطان"
          },
          {
            "governorate": "السويداء",
            "id": 981,
            "name_ar": "شهبا الخيرية"
          },
          {
            "governorate": "الحسكة",
            "id": 985,
            "name_ar": "الجمعية السورية للتنمية الاجتماعية "
          },
          {
            "governorate": "دمشق",
            "id": 1004,
            "name_ar": "اليقظة الخيرية"
          },
          {
            "governorate": "الحسكة",
            "id": 1010,
            "name_ar": "جمعية الاحسان"
          },
          {
            "governorate": "السويداء",
            "id": 1016,
            "name_ar": "المزرعة الخيرية"
          },
          {
            "governorate": "دمشق",
            "id": 1037,
            "name_ar": "تشارك"
          },
          {
            "governorate": "درعا",
            "id": 1043,
            "name_ar": "جمعية موثبين الخيرية"
          },
          {
            "governorate": "حماه",
            "id": 1044,
            "name_ar": "مؤسسة سبر للابداع والتنمية بحماة"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1051,
            "name_ar": "جمعية شقحب"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1058,
            "name_ar": "مؤسسة الأنصاف الخيرية"
          },
          {
            "governorate": "الرقة",
            "id": 1063,
            "name_ar": "جمعية الرافقة"
          },
          {
            "governorate": "اللاذقية",
            "id": 1071,
            "name_ar": "التماسك الاجتماعي"
          },
          {
            "governorate": "الرقة",
            "id": 1072,
            "name_ar": "جمعية التأثير"
          },
          {
            "governorate": "السويداء",
            "id": 1079,
            "name_ar": "محبة ووفا"
          },
          {
            "governorate": "حمص",
            "id": 1088,
            "name_ar": "مؤسسة العزم للريادة والتنمية "
          },
          {
            "governorate": "السويداء",
            "id": 1090,
            "name_ar": "رساس الخيرية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1132,
            "name_ar": "الرحمة المهداة الخيرية في معضمية الشام"
          },
          {
            "governorate": "اللاذقية",
            "id": 1141,
            "name_ar": "الربوة الخيرية"
          },
          {
            "governorate": "درعا",
            "id": 1142,
            "name_ar": "جمعية الاحسان الخيرية"
          },
          {
            "governorate": "دمشق",
            "id": 1150,
            "name_ar": "جذور"
          },
          {
            "governorate": "حمص",
            "id": 1172,
            "name_ar": "جمعية الرجاء "
          },
          {
            "governorate": "حمص",
            "id": 1173,
            "name_ar": "جمعية شباب الخير"
          },
          {
            "governorate": "اللاذقية",
            "id": 1189,
            "name_ar": "كبارنا"
          },
          {
            "governorate": "حلب",
            "id": 1228,
            "name_ar": "جمعية تنمية المجتمع المحلي"
          },
          {
            "governorate": "الحسكة",
            "id": 1232,
            "name_ar": "جمعية الرحمة"
          },
          {
            "governorate": "الحسكة",
            "id": 1269,
            "name_ar": "مؤسسةسرطان الأطفال ورعايتهم"
          },
          {
            "governorate": "حلب",
            "id": 1272,
            "name_ar": "جمعية البر والإحسان "
          },
          {
            "governorate": "حلب",
            "id": 1278,
            "name_ar": "جمعية معاً نرتقي"
          },
          {
            "governorate": "طرطوس",
            "id": 1284,
            "name_ar": "جمعية بدرية الخيرية "
          },
          {
            "governorate": "دمشق",
            "id": 1291,
            "name_ar": "القزاز للإغاثة والتنمية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1339,
            "name_ar": "جمعية ضاحية قدسيا"
          },
          {
            "governorate": "دير الزور",
            "id": 1359,
            "name_ar": "جمعية غيث التنموية"
          },
          {
            "governorate": "اللاذقية",
            "id": 1368,
            "name_ar": "مؤسسة الشهيد"
          },
          {
            "governorate": "دمشق",
            "id": 1371,
            "name_ar": "لمسة حنان الخيرية التنموية"
          },
          {
            "governorate": "طرطوس",
            "id": 1373,
            "name_ar": "أبناء لواء اسكندرون"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1388,
            "name_ar": "جمعية الهيئة الاجتماعية"
          },
          {
            "governorate": "دمشق",
            "id": 1394,
            "name_ar": "ارتقاء التنموية الخيرية"
          },
          {
            "governorate": "حلب",
            "id": 1413,
            "name_ar": "جمعية الأيتام المعوقين"
          },
          {
            "governorate": "اللاذقية",
            "id": 1420,
            "name_ar": "موزاييك للإغاثة والتنمية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1435,
            "name_ar": "مؤسسة سيريانا"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1440,
            "name_ar": "جمعية الحكمة الخيرية "
          },
          {
            "governorate": "ريف دمشق",
            "id": 1463,
            "name_ar": "سما الشام"
          },
          {
            "governorate": "دمشق",
            "id": 1464,
            "name_ar": "غراس"
          },
          {
            "governorate": "حماه",
            "id": 1492,
            "name_ar": "الجمعية السورية للتنمية البشرية بسلمية"
          },
          {
            "governorate": "حماه",
            "id": 1492,
            "name_ar": "فرع الجمعية السورية للتنمية الاجتماعية بحماة"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1500,
            "name_ar": "الرحمة النسائية الخيرية في سرغايا"
          },
          {
            "governorate": "دمشق",
            "id": 1513,
            "name_ar": "لأجلك سورية"
          },
          {
            "governorate": "الحسكة",
            "id": 1513,
            "name_ar": "لاجلك سورية"
          },
          {
            "governorate": "دمشق",
            "id": 1520,
            "name_ar": "الياسمين الدمشقي"
          },
          {
            "governorate": "اللاذقية",
            "id": 1526,
            "name_ar": "سوا الخيرية"
          },
          {
            "governorate": "حماه",
            "id": 1533,
            "name_ar": "فرع مؤسسة الشهيد في حماة"
          },
          {
            "governorate": "دمشق",
            "id": 1542,
            "name_ar": "ساعد"
          },
          {
            "governorate": "حمص",
            "id": 1544,
            "name_ar": "جمعية شعاع الامل "
          },
          {
            "governorate": "حلب",
            "id": 1545,
            "name_ar": "جمعية الشهيد المدني"
          },
          {
            "governorate": "الحسكة",
            "id": 1551,
            "name_ar": "جمعية الاسرة"
          },
          {
            "governorate": "اللاذقية",
            "id": 1559,
            "name_ar": "تساما"
          },
          {
            "governorate": "الرقة",
            "id": 1576,
            "name_ar": "مؤسسة سورية اليمامة"
          },
          {
            "governorate": "دمشق",
            "id": 1576,
            "name_ar": "القيسا الخيرية"
          },
          {
            "governorate": "الحسكة",
            "id": 1576,
            "name_ar": "مؤسسة سورية اليمامة"
          },
          {
            "governorate": "اللاذقية",
            "id": 1582,
            "name_ar": "مجلس الشباب السوري"
          },
          {
            "governorate": "طرطوس",
            "id": 1585,
            "name_ar": "جمعية فضا للتنمية المجتمعية"
          },
          {
            "governorate": "حمص",
            "id": 1593,
            "name_ar": "جمعية صامدون رغم الجراح "
          },
          {
            "governorate": "السويداء",
            "id": 1595,
            "name_ar": "سواعدنا"
          },
          {
            "governorate": "السويداء",
            "id": 1596,
            "name_ar": "عتيل الخيرية"
          },
          {
            "governorate": "حماه",
            "id": 1609,
            "name_ar": "جمعية جاد الخيرية في مصياف"
          },
          {
            "governorate": "الحسكة",
            "id": 1612,
            "name_ar": "جمعية العطاء"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1621,
            "name_ar": "جمعية الكسوة للأعمال الخيرية"
          },
          {
            "governorate": "الحسكة",
            "id": 1631,
            "name_ar": "جمعية نور سورية"
          },
          {
            "governorate": "الحسكة",
            "id": 1651,
            "name_ar": "جمعية الايخاء"
          },
          {
            "governorate": "حمص",
            "id": 1652,
            "name_ar": "جمعية بابل "
          },
          {
            "governorate": "الحسكة",
            "id": 1659,
            "name_ar": "مؤسسة الاماني "
          },
          {
            "governorate": "ريف دمشق",
            "id": 1662,
            "name_ar": "مؤسسة تمكين"
          },
          {
            "governorate": "دمشق",
            "id": 1663,
            "name_ar": "شمعة أمل"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1673,
            "name_ar": "نبض سورية"
          },
          {
            "governorate": "حلب",
            "id": 1682,
            "name_ar": "جمعية بكرا أحلى"
          },
          {
            "governorate": "الحسكة",
            "id": 1684,
            "name_ar": "جمعية ميسلون"
          },
          {
            "governorate": "إدلب",
            "id": 1689,
            "name_ar": "جمعية مزيد الخيرية "
          },
          {
            "governorate": "حماه",
            "id": 1696,
            "name_ar": "جمعية حوراء في سلمية"
          },
          {
            "governorate": "إدلب",
            "id": 1704,
            "name_ar": "جمعية بشرى الغد "
          },
          {
            "governorate": "ريف دمشق",
            "id": 1716,
            "name_ar": "جمعية نافذة الحياةلرعاية الايتام"
          },
          {
            "governorate": "السويداء",
            "id": 1722,
            "name_ar": "نساء السهوة بلاطة التنموية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1726,
            "name_ar": "جمعية يعفور الخيرية"
          },
          {
            "governorate": "حمص",
            "id": 1727,
            "name_ar": "جمعية فيروزة للعمل الخيري"
          },
          {
            "governorate": "القنيطرة",
            "id": 1737,
            "name_ar": "مؤسسة مبادرة اهل الشام"
          },
          {
            "governorate": "حلب",
            "id": 1744,
            "name_ar": "جمعية أمل الشهباء"
          },
          {
            "governorate": "دمشق",
            "id": 1748,
            "name_ar": "المرأة الأمة"
          },
          {
            "governorate": "القنيطرة",
            "id": 1749,
            "name_ar": "قلب الجولان"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1755,
            "name_ar": "جمعية حنين نور وامل"
          },
          {
            "governorate": "الحسكة",
            "id": 1756,
            "name_ar": "مؤسسة شام الخير"
          },
          {
            "governorate": "السويداء",
            "id": 1779,
            "name_ar": "ولفا الخيرية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1783,
            "name_ar": "السراج في عربين"
          },
          {
            "governorate": "حماه",
            "id": 1786,
            "name_ar": "جمعية قطرة امل لرعاية الطفولة في سلمية"
          },
          {
            "governorate": "اللاذقية",
            "id": 1787,
            "name_ar": "الشروق الخيرية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1791,
            "name_ar": "جمعية السعادة "
          },
          {
            "governorate": "حماه",
            "id": 1817,
            "name_ar": "جمعية صوت الخير في كفربهم"
          },
          {
            "governorate": "درعا",
            "id": 1831,
            "name_ar": "جمعية أفق للتنمية الانسانية"
          },
          {
            "governorate": "اللاذقية",
            "id": 1839,
            "name_ar": "أيادينا"
          },
          {
            "governorate": "دمشق",
            "id": 1847,
            "name_ar": "دفى"
          },
          {
            "governorate": "دمشق",
            "id": 1857,
            "name_ar": "حدودي السما"
          },
          {
            "governorate": "الرقة",
            "id": 1871,
            "name_ar": "جمعية قمح"
          },
          {
            "governorate": "طرطوس",
            "id": 1875,
            "name_ar": "السبيل الخيرية"
          },
          {
            "governorate": "حماه",
            "id": 1876,
            "name_ar": "جمعية النادي الاهلي في مصياف"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1884,
            "name_ar": "جمعية ومضات"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1910,
            "name_ar": "مؤسسة قناديل للتنمية المستدامة"
          },
          {
            "governorate": "السويداء",
            "id": 1921,
            "name_ar": "روز للتنمية"
          },
          {
            "governorate": "القنيطرة",
            "id": 1934,
            "name_ar": "همم"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1935,
            "name_ar": "اسرتي امانتي"
          },
          {
            "governorate": "الحسكة",
            "id": 1940,
            "name_ar": "جمعية المناهل"
          },
          {
            "governorate": "الرقة",
            "id": 1941,
            "name_ar": "جمعية نبراس"
          },
          {
            "governorate": "القنيطرة",
            "id": 1943,
            "name_ar": "انانا"
          },
          {
            "governorate": "دمشق",
            "id": 1944,
            "name_ar": "جيلنا"
          },
          {
            "governorate": "الرقة",
            "id": 1957,
            "name_ar": "جمعية ذهب"
          },
          {
            "governorate": "طرطوس",
            "id": 1959,
            "name_ar": "مؤسسة كون"
          },
          {
            "governorate": "السويداء",
            "id": 1963,
            "name_ar": "ريمة حازم"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1969,
            "name_ar": "كنانة الشام"
          },
          {
            "governorate": "ريف دمشق",
            "id": 1973,
            "name_ar": "جمعية مجال"
          },
          {
            "governorate": "حماه",
            "id": 1982,
            "name_ar": "جمعية خزامى في حماة"
          },
          {
            "governorate": "اللاذقية",
            "id": 1987,
            "name_ar": "ورد وغار"
          },
          {
            "governorate": "السويداء",
            "id": 1988,
            "name_ar": "سوريانا الخيرية"
          },
          {
            "governorate": "اللاذقية",
            "id": 1998,
            "name_ar": "نسور المدائن"
          },
          {
            "governorate": "حلب",
            "id": 2004,
            "name_ar": "مؤسسة سوريا بتجمعنا"
          },
          {
            "governorate": "اللاذقية",
            "id": 2004,
            "name_ar": "سوريا بتجمعنا"
          },
          {
            "governorate": "دير الزور",
            "id": 2018,
            "name_ar": "جمعية تكاتف شبابي"
          },
          {
            "governorate": "السويداء",
            "id": 2032,
            "name_ar": "الطفل اليتيم"
          },
          {
            "governorate": "السويداء",
            "id": 2037,
            "name_ar": "مرساة"
          },
          {
            "governorate": "القنيطرة",
            "id": 2046,
            "name_ar": "قلبي معكم"
          },
          {
            "governorate": "دمشق",
            "id": 2049,
            "name_ar": "الواعدون للتنمية المجتمعية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 2049,
            "name_ar": "جمعية الواعدون"
          },
          {
            "governorate": "ريف دمشق",
            "id": 2052,
            "name_ar": "جمعية سياج الياسمين"
          },
          {
            "governorate": "ريف دمشق",
            "id": 2054,
            "name_ar": "مؤسسة شهد"
          },
          {
            "governorate": "دير الزور",
            "id": 2055,
            "name_ar": "جمعية رعاية المساجين"
          },
          {
            "governorate": "دمشق",
            "id": 2070,
            "name_ar": "ملتقى الأسرة السورية"
          },
          {
            "governorate": "اللاذقية",
            "id": 2070,
            "name_ar": "ملتقى الأسرة السورية"
          },
          {
            "governorate": "إدلب",
            "id": 2089,
            "name_ar": "جمعية افاق السورية للتنمية "
          },
          {
            "governorate": "اللاذقية",
            "id": 2091,
            "name_ar": "بسمة قلب"
          },
          {
            "governorate": "الحسكة",
            "id": 2095,
            "name_ar": "جمعية وتين"
          },
          {
            "governorate": "الحسكة",
            "id": 2096,
            "name_ar": "جمعية نسمة "
          },
          {
            "governorate": "اللاذقية",
            "id": 2115,
            "name_ar": "طوق الياسمين"
          },
          {
            "governorate": "القنيطرة",
            "id": 2120,
            "name_ar": "الرسالة"
          },
          {
            "governorate": "درعا",
            "id": 2126,
            "name_ar": "جمعية ازرع الخيرية"
          },
          {
            "governorate": "الرقة",
            "id": 2134,
            "name_ar": "جمعية يمنى"
          },
          {
            "governorate": "دمشق",
            "id": 2137,
            "name_ar": "تدعيم التنموية"
          },
          {
            "governorate": "القنيطرة",
            "id": 2153,
            "name_ar": "رفيف الاماني"
          },
          {
            "governorate": "الرقة",
            "id": 2166,
            "name_ar": "جمعية الرصافة"
          },
          {
            "governorate": "درعا",
            "id": 2168,
            "name_ar": "جمعية العالية الخيرية"
          },
          {
            "governorate": "ريف دمشق",
            "id": 2169,
            "name_ar": "مؤسسة فكر وقلب"
          },
          {
            "governorate": "الرقة",
            "id": 2173,
            "name_ar": "جمعية عبق الفرات"
          },
          {
            "governorate": "القنيطرة",
            "id": 2174,
            "name_ar": "المى الخيرية"
          },
          {
            "governorate": "حماه",
            "id": 2177,
            "name_ar": "جمعين المعين الخيرية في الغاب"
          },
          {
            "governorate": "إدلب",
            "id": 2183,
            "name_ar": "مؤسسة قادرون للتنمية "
          },
          {
            "governorate": "درعا",
            "id": 2187,
            "name_ar": "مؤسسة أنهار"
          },
          {
            "governorate": "القنيطرة",
            "id": 2189,
            "name_ar": "اشراقة امل"
          },
          {
            "governorate": "القنيطرة",
            "id": 2190,
            "name_ar": "زايد الخير"
          },
          {
            "governorate": "السويداء",
            "id": 2193,
            "name_ar": "النصر"
          },
          {
            "governorate": "حلب",
            "id": 2196,
            "name_ar": "مؤسسة روح الإبداع"
          },
          {
            "governorate": "درعا",
            "id": 2197,
            "name_ar": "جمعيد دير العدس الخيرية"
          },
          {
            "governorate": "اللاذقية",
            "id": 2199,
            "name_ar": "النخيل"
          }
          ],
        pagination:{
          current_page:1 ,
          last_page: 96 ,
          per_page: 16 ,
          total_row: 260
        }
      },
      statisticsCards: [
        // {
        //   title: "تخصيص حسابات للتبرعات المالية الخاصة بكارثة الزلزال",
        //   rightNumber: "3",
        //   rightText: "حساب",
        //   leftNumber: "1",
        //   leftText: "المنظمات المساهمة",
        //   img: require("./assets/Stacks of Syrian pounds.jpg"),
        // },
      ],
      swiperOptions: {
        loop: "true",
        Parallax: true,
        spaceBetween: 0,
        centeredSlides: true,
        speed: 900,
        effect: "fade",
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  
  watch: {
    currentPage(value) {
      console.log("value" , value , (value-1)*16, ((value)*16)-1)
     this.ngo_list.data = this.all_data.data.slice((value-1)*16, ((value)*16));
    },
  },
  mounted() {
    this.currentPage = 1
  },
};
</script>
<style lang="scss">
.bacg {
  height:700px
}
.earthquake-page {
  .featured-container {
    display: flex;
    justify-content: space-around;
  }

  @media screen and (min-width: 300px) {
    .featured-container {
      flex-direction: column;
    }
    .featured-card {
      width: 100%;
    }
  }
  @media screen and (min-width: 1200px) {
    .featured-container {
      flex-direction: row;
    }
    .featured-card {
      width: 35%;
    }
  }
  .card {
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
  }
  .col-4 {
    padding: 2rem 1.5rem;
  }
  .card-img-top {
    object-fit: cover;
    height: 180px;
  }
  .title-radius {
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
}
.bacg {
  z-index: 10;
  background-image: url("/images/slider/01.jpg");
  background-size: cover;
  background-position: 50% 50%;
  width: inherit;
  min-height: 700px;
  filter: grayscale(20%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  .w-100{
    min-height: 700px;
  }
  .title_des {
    width: 35%;
    margin-left: 70px;
  }
  .b_slider {
    margin-top: 20px;
    font-size: 20px;
    line-height: 25px;
    text-align: justify;
  }
}

@media (max-width: 550px) {
  .bacg {
    min-height: 300px;
    justify-content: flex-end;

    .title_des {
      width: 70%;
      margin-left: 70px;

      div {
        h3 {
          font-size: 18px;
        }
      }
    }
    .b_slider {
      font-size: 13px;
    }
  }
}
</style>
